import { ListItemButton, ListItemText, Checkbox } from "@mui/material"
import PropTypes from "prop-types"
import { MetricTypeOptionShape } from "./helpers/prop-types"

export default function MetricType({
  option,
  toggleSelectedMetricColumn,
  disableOptions,
  getIsSelected,
}) {
  const isSelected = getIsSelected(option.selector)
  const isDisabled = !isSelected && disableOptions

  return <ListItemButton
    disabled={isDisabled}
    classes={{ root: "list-item" }}
    className="metrics-type"
    onClick={() => toggleSelectedMetricColumn(option.selector)}
  >
    <Checkbox
      color="primary"
      className="metrics-checkbox"
      // Need to set tabIndex to -1 because the parent element is a button that controls the checkbox state
      tabIndex={-1}
      checked={isSelected}
      disableRipple
      disabled={isDisabled}
    />
    <ListItemText>{option.label}</ListItemText>
  </ListItemButton>
}

MetricType.propTypes = {
  option: MetricTypeOptionShape.isRequired,
  toggleSelectedMetricColumn: PropTypes.func.isRequired,
  disableOptions: PropTypes.bool.isRequired,
  getIsSelected: PropTypes.func.isRequired,
}
